import React from 'react'
import { useTranslation } from '@i18n'
import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
  differenceInYears,
  format,
} from 'date-fns'

const PopTime = (props) => {
  const { t } = useTranslation('poptime')
  const { className, prefix = '', time } = props

  if (!time) return null

  const now = Date.now()
  const diff = {
    second: differenceInSeconds(now, time),
    minute: differenceInMinutes(now, time),
    hour: differenceInHours(now, time),
    day: differenceInDays(now, time),
    week: differenceInWeeks(now, time),
    month: differenceInMonths(now, time),
    year: differenceInYears(now, time),
  }
  let timeCount = format(time, diff.year === 0 ? 'MM-dd' : 'yyyy-MM-dd')
  if (diff.second > 0 && diff.second < 120) {
    timeCount = t('just') // over 0s ~ 2mins(120s)
  } else if (diff.second >= 120 && diff.minute < 59) {
    timeCount = t('minsAgo', { count: diff.minute }) // over 2mins ~ 59mins
  } else if (diff.hour >= 1 && diff.hour < 24) {
    timeCount = t('nHoursAgo', { count: diff.hour }) // over 1hour ~ 24hours
  } else if (diff.hour >= 24 && diff.day < 7) {
    timeCount = t('nDaysAgo', { count: diff.day }) // over 1day ~ 1week
  } else if (diff.day >= 7 && diff.week < 4 && diff.month < 1) {
    timeCount = t('nWeeksAgo', { count: diff.week }) // over 7days ~ 1month
  } else if (diff.month >= 1 && diff.Year < 1) {
    timeCount = t('nMonthsAgo', { count: diff.month }) // over 1month ~ 1year
  } else if (diff.year >= 1) {
    timeCount = t('nYearsAgo', { count: diff.year }) // over 1year
  }

  return (
    <time className={className} dateTime={new Date(time).toISOString()}>
      {`${prefix} ${timeCount}`}
    </time>
  )
}

export default PopTime
